import type { LogRateResponse } from '@central/api';

/** "per minute", "per 12 min", "per 6 h": the bucket width of a rate. */
export function rateUnit(stepSeconds: number): string {
  const min = Math.round(stepSeconds / 60);
  if (min <= 1) return 'per minute';
  return min % 60 === 0 ? `per ${min / 60} h` : `per ${min} min`;
}

/** The chart's caption numbers: total lines and the first busiest bucket. */
export function describeRate(r: LogRateResponse): {
  total: number;
  peak?: { at: string; count: number };
} {
  let total = 0;
  let peak: { at: string; count: number } | undefined;
  for (const p of r.points) {
    total += p.count;
    if (p.count > 0 && (!peak || p.count > peak.count)) peak = p;
  }
  return { total, peak };
}
